import { render } from "./YouTube.vue?vue&type=template&id=38535678&bindings={}"
import script from "./YouTube.vue?vue&type=script&lang=ts"
export * from "./YouTube.vue?vue&type=script&lang=ts"
script.render = render

export default script